import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { fetchSfdcUsers, type SfdcUser } from '../event-manager-client';

export function useSfdcUsers() {
  const { apiFetch } = useApi();

  const query = useQuery<SfdcUser[]>({
    queryKey: ['launcher', 'sfdc-users'],
    queryFn: () => fetchSfdcUsers(apiFetch),
    staleTime: Infinity,
  });

  return {
    users: query.data ?? [],
    isLoading: query.isLoading,
  };
}
